"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceRadio = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formRadio = require("../form-radio/form-radio");
var _excluded = ["name", "value", "title", "price", "description", "disabled"];
var PriceRadio = exports.PriceRadio = function PriceRadio(_ref) {
  var name = _ref.name,
    value = _ref.value,
    title = _ref.title,
    price = _ref.price,
    description = _ref.description,
    disabled = _ref.disabled,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var inputId = "".concat(name, "-").concat(value);
  var priceClasses = (0, _classnames["default"])(['price-radio__price', 'text_lg', {
    'text_color-secondary': disabled
  }]);
  var descriptionClasses = (0, _classnames["default"])(['price-radio__description', 'text_md', {
    'text_color-secondary': disabled
  }]);
  return /*#__PURE__*/_react["default"].createElement(_formRadio.FormRadio, (0, _extends2["default"])({
    id: inputId,
    disabled: disabled,
    name: name,
    value: value,
    labelClasses: "price-radio"
  }, inputProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: "price-radio__details"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "price-radio__primary-details"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "price-radio__title text_xl"
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: priceClasses
  }, price)), description && /*#__PURE__*/_react["default"].createElement("span", {
    className: descriptionClasses
  }, description)));
};